import classNames from 'classnames';
import { Icon, IconProps } from '~/components/Icon/Icon';

export type TwitterProps = IconProps;
export const Twitter = ({ className, ...props }: TwitterProps) => (
  <Icon
    className={classNames('twitter', className)}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}>
    <path
      d="M13.8144 10.5452L20.7355 2.5H19.0954L13.0859 9.48554L8.28604 2.5H2.75L10.0083 13.0634L2.75 21.5H4.39017L10.7364 14.123L15.8054 21.5H21.3415L13.814 10.5452H13.8144ZM11.568 13.1564L10.8326 12.1046L4.98114 3.7347H7.50035L12.2225 10.4894L12.9579 11.5413L19.0962 20.3215H16.577L11.568 13.1568V13.1564Z"
      fill="currentColor"
    />
  </Icon>
);
